import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ControlBase } from '../controls-base';

@Component({
  selector: 'app-yes-no-input',
  templateUrl: './yes-no-input.component.html',
  styleUrls: ['./yes-no-input.component.scss']
})
export class YesNoInputComponent implements OnInit {
  @Input() meta!: ControlBase;
  @Input() form!: FormGroup;
  @Input() formMarkAsTouched!: boolean;


  constructor() { }

  ngOnInit(): void {
  }

  get selfControl() {
    return this.form.controls[`${this.meta.fieldId}`];
  }
}
